import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { getCmdChartDefaultsSelector, getDatapointsConfigSelector } from '../../../configurations/selectors'
import { ICmdFacChartDefaults, IDataPointsConfig } from '../../../configurations/store/configurations.types'
import { setDefaultValue } from '../../../../utilities/data.util'
import { getCardioOptionsSelector } from '../../../options/selectors'
import { ICardioOptionsState } from '../../../options/store/options.types'
import { saveInitialAssessmentCardioNabc, setCvTempDegrees } from '../store/cardio.actions'
import { setPulses } from '../pulses/store/pulses.actions'
import { getDefaultTempTypeSelector } from '../../../configurations/selectors/defaultTempType.selector'
import { getPcrIdSelector } from '../../../home/selectors'
import { getServiceIdSelector } from '../../../user/selectors'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { IPcr } from '../../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { InitialAssessmentConstants } from '../../store/initialAssessment.constants'

export function* setCardioDefaults() {
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    if (!pcrDoc.prNabc) {
      const defaultTempType: string = yield select(getDefaultTempTypeSelector)
      const datapointsConfig: IDataPointsConfig = yield select(getDatapointsConfigSelector)
      const cmdChartDefaults: ICmdFacChartDefaults = yield select(getCmdChartDefaultsSelector)
      const cardioOptions: ICardioOptionsState = yield select(getCardioOptionsSelector)
      const {
        PULSE_BRA_L,
        PULSE_BRA_R,
        PULSE_CAROTID_L,
        PULSE_CAROTID_R,
        PULSE_FEM_L,
        PULSE_FEM_R,
        PULSE_RAD_L,
        PULSE_RAD_R,
        PULSE_DORS_L,
        PULSE_DORS_R,
        CV_CAP_REFILL,
        CV_JVD,
        CV_EDEMA,
      } = cmdChartDefaults
      const { pulsesOptions, cvJvdOptions, cvEdemaOptions, cvCapRefillOptions } = cardioOptions
      const { DP_SHOWDEFAULTS, DP_PULSE_DORS, DP_EDEMA } = datapointsConfig
      try {
        yield put(setCvTempDegrees(defaultTempType?.toUpperCase()) || 'F')

        if (DP_SHOWDEFAULTS) {
          const pulseBraL = setDefaultValue(pulsesOptions, PULSE_BRA_L)
          const pulseBraR = setDefaultValue(pulsesOptions, PULSE_BRA_R)

          const pulseCarotid = setDefaultValue(pulsesOptions, PULSE_CAROTID_L)
          const pulseCarotidR = setDefaultValue(pulsesOptions, PULSE_CAROTID_R)

          const pulseFemL = setDefaultValue(pulsesOptions, PULSE_FEM_L)
          const pulseFemR = setDefaultValue(pulsesOptions, PULSE_FEM_R)

          const pulseRadL = setDefaultValue(pulsesOptions, PULSE_RAD_L)
          const pulseRadR = setDefaultValue(pulsesOptions, PULSE_RAD_R)

          const pulseDorsL = setDefaultValue(pulsesOptions, PULSE_DORS_L, DP_PULSE_DORS)
          const pulseDorsR = setDefaultValue(pulsesOptions, PULSE_DORS_R, DP_PULSE_DORS)

          const pulseItems = {
            pulseBraL,
            pulseBraR,
            pulseCarotid,
            pulseCarotidR,
            pulseFemL,
            pulseFemR,
            pulseRadL,
            pulseRadR,
            pulseDorsL,
            pulseDorsR,
          }

          yield put(setPulses(pulseItems))

          const cvEdema = setDefaultValue(cvEdemaOptions, CV_EDEMA, DP_EDEMA)
          const cvJvd = setDefaultValue(cvJvdOptions, CV_JVD)
          const cvCapRefill = setDefaultValue(cvCapRefillOptions, CV_CAP_REFILL)

          const cardioItems = { cvEdema, cvJvd, cvCapRefill }
          yield put(saveInitialAssessmentCardioNabc(cardioItems))
        }
      } catch (e) {
        yield put(throwPcrException(`setCardioDefaults() error: ${e}`))
      }
    }
  }
}

export function* setCardioDefaultsSaga() {
  yield takeLatest([InitialAssessmentConstants.SET_PR_NABC_DEFAULTS], performWithMutexHOG, setCardioDefaults)
}
